export default __webpack_public_path__ + "static/rocket-e8327fd29bba2f6a0a736294254d4104.png";